import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICE_PROVIDER_SUBSCRIPTIONS_URL = "organization/subscription-plan";
const API_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_URL = "organization/subscription-plan-history";
const API_SERVICE_PROVIDER_SUBSCRIPTIONS_MODULE_LIST_URL = API_SERVICE_PROVIDER_SUBSCRIPTIONS_URL + "/list";
const API_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_MODULE_LIST_URL = API_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_URL + "/list";
const API_SERVICE_PROVIDER_ORGANIZATION_SPONSORSHIP_HISTORY_MODULE_LIST_URL = "organization/organization-top-listing-subscription-plan-history" + "/list";
const API_SERVICE_PROVIDER_PUSH_NOTIFICATION_HISTORY_MODULE_LIST_URL = "organization/push-notifications" + "/list";
const API_ADMIN_SUBSCRIPTIONS_URL = "admin/subscription-plan";
const API_ADMIN_SUBSCRIPTIONS_MODULE_LIST_URL = API_ADMIN_SUBSCRIPTIONS_URL + "/list";
const UPDATE_SUBSCRIPTION_PLAN_BY_ID_URL = API_ADMIN_SUBSCRIPTIONS_URL + "/update";
const UPDATE_SUBSCRIPTION_PLAN_AUTO_CREDIT_BY_ID_URL = "admin/system-settings/update_auto_credit";

export const getServiceProviderSubscriptions = () => {
  return axiosInstance.get(`${API_SERVICE_PROVIDER_SUBSCRIPTIONS_MODULE_LIST_URL}`);
};
export const getServiceProviderSubscriptionPlanHistory = (dataToBeSent) => {
  return axiosInstance.get(`${API_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""
  }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&filters[type]=${dataToBeSent?.type || ""}`);
};

export const getServiceProviderOrganizationSponsorshipHistory = (dataToBeSent) => {
  return axiosInstance.get(`${API_SERVICE_PROVIDER_ORGANIZATION_SPONSORSHIP_HISTORY_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""
  }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&filters[type]=${dataToBeSent?.type || ""}`);
};

export const getServiceProviderPushNotificationHistory = (dataToBeSent) => {
  return axiosInstance.get(`${API_SERVICE_PROVIDER_PUSH_NOTIFICATION_HISTORY_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""
  }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const getSuperAdminSubscriptions = () => {
  return axiosInstance.get(`${API_ADMIN_SUBSCRIPTIONS_MODULE_LIST_URL}`);
};

export const updateSubscriptionPlanAutoCredit = (dataToBeSent) => {
  return axiosInstance.post(
    `${UPDATE_SUBSCRIPTION_PLAN_AUTO_CREDIT_BY_ID_URL}`,
    dataToBeSent
  );
};

export const updateSubscriptionPlan = (id, dataToBeSent) => {
  return axiosInstance.post(
    `${UPDATE_SUBSCRIPTION_PLAN_BY_ID_URL}/${id}`,
    dataToBeSent
  );
};
